var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCypressDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_1190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 0H60C26.8629 0 0 26.8629 0 60V196C0 229.137 26.8629 256 60 256H196C229.137 256 256 229.137 256 196V60C256 26.8629 229.137 0 196 0Z",
    fill: "#242938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.859 109.68C108.837 109.68 114.507 113.411 117.414 119.891L117.632 120.401L129.335 116.415L129.099 115.814C124.574 104.747 114.125 97.8843 101.859 97.8843C93.2268 97.8843 86.2123 100.651 80.4153 106.348C74.6547 112.01 71.7471 119.127 71.7471 127.5C71.7471 135.819 74.6728 142.899 80.4153 148.542C86.2123 154.24 93.2268 157.006 101.859 157.006C114.125 157.006 124.556 150.126 129.099 139.077L129.335 138.476L117.614 134.49L117.414 135.018C114.797 141.407 108.982 145.211 101.859 145.211C97.0067 145.211 92.8997 143.518 89.665 140.169C86.3758 136.783 84.7222 132.506 84.7222 127.5C84.7222 122.458 86.3395 118.271 89.665 114.722C92.9179 111.372 97.0067 109.68 101.859 109.68Z",
    fill: "#1B1E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.669 210.085L149.18 198.563C180.654 188.988 201.807 160.428 201.807 127.5C201.807 118.417 200.19 109.534 196.991 101.124L208.222 96.8467C211.947 106.64 213.837 116.942 213.837 127.518C213.819 165.762 189.25 198.945 152.669 210.085Z",
    fill: "url(#paint0_linear_36_1190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.554 105.73C188.941 74.312 160.392 53.2152 127.5 53.2152C123.029 53.2152 118.559 53.6156 114.198 54.3983L112.072 42.5484C117.123 41.6383 122.321 41.165 127.5 41.165C165.698 41.165 198.863 65.684 210.039 102.18L198.554 105.73Z",
    fill: "#69D3A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7056 157.935C43.0347 148.215 41.1812 137.967 41.1812 127.5C41.1812 82.9038 74.6002 45.9707 118.923 41.6021L120.104 53.5794C81.96 57.3473 53.1931 89.1291 53.1931 127.5C53.1931 136.511 54.7923 145.339 57.9361 153.694L46.7056 157.935Z",
    fill: "url(#paint1_linear_36_1190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.148 98.9766L158.484 141.279L141.693 98.9766H127.954L151.506 156.715L134.351 198.399L146.363 200.802L188.123 98.9766H175.148Z",
    fill: "#1B1E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.513 193.157L133.987 199.291C133.406 200.693 132.079 201.657 130.589 201.712C129.553 201.748 128.536 201.785 127.482 201.785C94.4988 201.785 65.1322 179.669 56.0642 147.996L44.5066 151.309C55.0466 188.096 89.1561 213.799 127.464 213.817H127.482C128.681 213.817 129.88 213.799 131.08 213.744C137.24 213.489 142.746 209.612 145.109 203.878L148.525 195.56L136.513 193.157Z",
    fill: "url(#paint2_linear_36_1190)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_1190",
    x1: 220.45,
    y1: 128.046,
    x2: 143.302,
    y2: 177.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0814251,
    stopColor: "#69D3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69D3A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_1190",
    x1: 98.7665,
    y1: 42.2567,
    x2: 50.2146,
    y2: 145.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69D3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    stopColor: "#2AB586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CAE7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36_1190",
    x1: 41.059,
    y1: 167.026,
    x2: 168.061,
    y2: 206.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0773521,
    stopColor: "#1CAE7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1638,
    stopColor: "#1CA379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    stopColor: "#1C8568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    stopColor: "#1B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7187,
    stopColor: "#1B1E2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_1190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypressDark);
export default __webpack_public_path__ + "static/media/Cypress-Dark.f5889f3984df174d0baa78fc091f2778.svg";
export { ForwardRef as ReactComponent };